import React from 'react'

export const CopyUrlSvg = ({ size = 40 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 40 40"
  >
    <g fill="none" fillRule="evenodd">
      <circle cx="20" cy="20" r="20" fill="#11042F" fillRule="nonzero" />
      <path
        fill="#FFF"
        d="M13.256 12.678h11c1.105 0 2 .895 2 2v13.205c0 1.105-.895 2-2 2h-11c-1.104 0-2-.895-2-2V14.678c0-1.105.896-2 2-2z"
      />
      <path
        stroke="#FFF"
        strokeLinecap="round"
        strokeWidth="1.5"
        d="M17.213 9.5h7.309c2.746 0 4.972 2.282 4.972 5.098v8.21"
      />
    </g>
  </svg>
)
